package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class CompanyResponsiblePersonResponseItem(
    val id: Long? = null,
    val firstName: String? = null,
    val lastName: String? = null,
    val phoneNumber: String? = null,
    val dialCode: String? = null
)

@Serializable
data class GetMerchantMenuDataResponseModel(
    val iban: String? = null,
    val ibanConfirmationDate: String? = null, // Date when IBAN was confirmed (ISO format)
    val companyName: String? = null,
    val companyResponsiblePersons: List<CompanyResponsiblePersonResponseItem> = emptyList()
) : BaseResponseModel()

